// Mount-time configuration the Theme App Extension liquid block hands to the
// widget via data-* attributes on a placeholder div. We require shopDomain +
// chatEndpoint; everything else falls back to a reasonable default sourced
// from the merchant's saved theme config (replicated into the data- attrs by
// the liquid template).

export interface WidgetConfig {
  shopDomain: string;
  chatEndpoint: string;
  greeting: string;
  primaryColor: string;
  position: 'bottom-right' | 'bottom-left';
}

export class WidgetConfigError extends Error {}

export function readConfig(host: HTMLElement): WidgetConfig {
  const shopDomain = host.dataset['shopDomain'];
  const chatEndpoint = host.dataset['chatEndpoint'];
  if (!shopDomain) throw new WidgetConfigError('missing data-shop-domain on mount target');
  if (!chatEndpoint) throw new WidgetConfigError('missing data-chat-endpoint on mount target');

  const positionRaw = host.dataset['position'];
  const position: WidgetConfig['position'] =
    positionRaw === 'bottom-left' ? 'bottom-left' : 'bottom-right';

  const primaryColorRaw = host.dataset['primaryColor'];
  const primaryColor = /^#[0-9a-fA-F]{6}$/.test(primaryColorRaw ?? '')
    ? (primaryColorRaw as string)
    : '#1f2937';

  return {
    shopDomain,
    chatEndpoint,
    greeting: host.dataset['greeting'] ?? 'Hi! How can I help you today?',
    primaryColor,
    position,
  };
}
